import {LogLevel} from "angular-auth-oidc-client";
import {KeycloakService} from "keycloak-angular";
import {environment} from 'src/environments/environment';

export const keycloackCloackConf = {
  keycloak: {
    authority: 'https://antea.iss.it/test/iam/',
    redirectUrl: 'http://localhost:4200/login_success',
    postLogoutRedirectUri: 'localhost:4200',
    clientId: 'antea_test',
    scope: 'openid profile email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    startCheckSession: true,
    logLevel: LogLevel.Error,
    historyCleanupOff: false,
    realms: 'antea'
  },
}

export function initializeKeycloak(keycloak: KeycloakService) {
  return async () => {
    await keycloak.init({
      config: {
        url: environment.keycloak.authority,
        realm: environment.keycloak.realms,
        clientId: environment.keycloak.clientId
      },
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false,
        silentCheckSsoFallback: false
      },
      enableBearerInterceptor: true,
      bearerPrefix: 'Bearer',
      bearerExcludedUrls: ['/assets']
    });

  }
}
